import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseListComponent } from 'src/modules/sm-base/components/admin-base-list/admin-base-list.component';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { Objects } from "src/modules/utils/shared/objects";
import { ProjectPlanningTools } from "../../models/project-planning-tools.model";
import { Resource } from '../../netgen/Resource';
import { ProjectPlanningService } from '../../services/project-planning.service';

@Component({
    selector: 'app-edit-resources',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditResourcesComponent extends AdminBaseListComponent<Resource> {

    service = inject(ProjectPlanningService);
    
    definition = ProjectPlanningTools.definitionResource;
        
    getTable(): TableData {
        return this.app.tTable("entity.Resource.fields", new TableData([
            new TableColumn("color", "", TableCellType.color, 1),
            new TableColumn("title", "", TableCellType.string, 50),
            new TableColumn("mail", "", TableCellType.string, 50),
            new TableColumn("resourceType", this.app.t("entity.Resource.fields.typeId"), TableCellType.string, 30)
        ], this.listData.map(o => new TableRow(Objects.toString(o.id), o, {
            color: o.color,
            title: o.title,
            mail: o.mail,
            resourceType: this.service.getResourceType(o.typeId)?.title ?? ""
        })), ["title"]));
    }

    async initAdditionalData(): Promise<void> {
        await this.service.getResourceTypes();
    }
}
